import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { FronteggProvider } from "@frontegg/react";
import './index.css';
import App from './App';
import SalesforceSSO from './SalesforceSSO';
import BlackDiamondSSO from './BlackDiamondSSO';
import MoneyGuideProSSO from './MoneyGuideProSSO';
import AdhesionSSO from './AdhesionSSO';
import StratifiSSO from './StratifiSSO';
import BoxSSO from './BoxSSO';

const tenantResolver = (): { tenant: string | null } => {
  const baseUrl = process.env.REACT_APP_TENANT_BASE_URL || '';
  const tenant = window.location.host
    .replace(baseUrl, '')
    .replace('.', '') || 'auth-portal';

  return {
    tenant: tenant
  };
};

const contextOptions = {
  baseUrl: process.env.REACT_APP_FRONTEGG_BASE_URL || '',
  clientId: process.env.REACT_APP_FRONTEGG_CLIENT_ID || '',
  appId: process.env.REACT_APP_FRONTEGG_APP_ID || '',
  tenantResolver,
};

const authOptions = {
  keepSessionAlive: true,
  enableSessionPerTenant: true,
  disableSilentRefresh: false, // the flag is true by default. To disable it, pass false
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Router>
    <FronteggProvider contextOptions={contextOptions} hostedLoginBox={true} authOptions={authOptions}>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/sso-salesforce" element={<SalesforceSSO />} />
        <Route path="/sso-moneyguidepro" element={<MoneyGuideProSSO />} />
        <Route path="/sso-blackdiamond" element={<BlackDiamondSSO />} />
        <Route path="/sso-adhesion" element={<AdhesionSSO />} />
        <Route path="/sso-stratifi" element={<StratifiSSO />} />
        <Route path="/sso-box" element={<BoxSSO />} />
      </Routes>
    </FronteggProvider>
  </Router>,
);
